export const API_ENDPOINT_STORAGE_S3_LIST = `${process.env.REACT_APP_API_URL}/storage/objects/list`;
export const API_ENDPOINT_STORAGE_S3_ADD_FOLDER = `${process.env.REACT_APP_API_URL}/storage/objects/folder/add`;
export const API_ENDPOINT_STORAGE_S3_UPLOAD = `${process.env.REACT_APP_API_URL}/storage/objects/upload`;
export const API_ENDPOINT_STORAGE_S3_READ_FILE = `${process.env.REACT_APP_API_URL}/storage/objects/read`;
